$(window).load(function(){
	if ($(".menu-horizontal-gris").length > 0 ){
    	var elementContenidoMenu = window.location.hash;
    	$( 'a[href*='+elementContenidoMenu+']' ).trigger("click");
    }
});